export * from './chacras/chacras-map-detail.component';
export * from './base-dialog/base-dialog-map-detail.component';
